import { createTheme, styled } from '@mui/system';
import { emulatorScreen, laptopScreen, mobileScreen } from '../../utils/index.js';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Button, Typography, Grid } from "@mui/material";


// Create a theme instance
const theme = createTheme();
export default {
  Title: styled(Typography)({
    display: "flex",
    width: "100%",
    minHeight: 50,
    justifyContent: "center",
    alignItems: "center",
    fontSize: 40,
    letterSpacing: 1,
    color: "#003E4C",
    fontWeight: 600,
    fontFamily: "Oswald",
    lineHeight: 1.2,
    textAlign: "center",
    [emulatorScreen(theme)]: {
      fontSize: 30,
    },
    [laptopScreen(theme)]: {
      fontSize: 28,
      minHeight: 40,
    },
    [mobileScreen(theme)]: {
      fontSize: 20,
      minHeight: 20,
    },
  }),

  GraphHeading: styled(Typography)({
    display: "flex",
    width: "100%",
    minHeight: 50,
    justifyContent: "center",
    alignItems: "center",
    fontSize: 26,
    letterSpacing: 1,
    color: "#003E4C",
    fontWeight: 600,
    fontFamily: "Oswald",
    lineHeight: 1.2,
    textAlign: "center",
    flexWrap: "wrap",
    [emulatorScreen(theme)]: {
      fontSize: 22,
    },
    [laptopScreen(theme)]: {
      fontSize: 20,
      minHeight: 44,
    },
    [mobileScreen(theme)]: {
      fontSize: 14,
      minHeight: 20,
    },
  }),

  QuestionMarkers: styled(QuestionMarkIcon)({
    fontSize: 16,
    fontWeight: 700,
    background: "#3b3b3b",
    borderRadius: "50%",
    color: "#fff",
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [mobileScreen(theme)]: {
      fontSize: 10,
    }
  }),

  pieChartStyle: styled(Grid)({
    marginLeft: "10%",
    width: "100%",
    [emulatorScreen(theme)]: {
      marginLeft: "4%",
    },
    [mobileScreen(theme)]: {
      marginLeft: "0%",
    }
  }),

  TotalText: styled(Typography)({
    fontSize: 30,
    fontWeight: 400,
    fontFamily: "Oswald",
    marginRight: "10%",
    [emulatorScreen(theme)]: {
      fontSize: 24,
    },
    [mobileScreen(theme)]: {
      fontSize: 20,
    }
  }),

  PercentageText: styled(Typography)({
    fontSize: 36,
    fontWeight: 800,
    fontFamily: "Oswald",
    marginRight: "10%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18
    }
  }),

  // PercentageText: styled(Typography)({
  //   fontSize: 36,
  //   fontWeight: 800,
  //   fontFamily: "Oswald",
  //   marginRight: "10%",
  //   [emulatorScreen(theme)]: {
  //   },
  //   [mobileScreen(theme)]: {
  //     fontSize: 18
  //   }
  // }),

  Number: styled(Typography)({
    fontSize: 36,
    fontWeight: 800,
    fontFamily: "Oswald",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18
    }
  }),

  SubmmitButton: styled(Button)({
    color: "#fff",
    fontSize: "34px",
    fontWeight: "500",
    padding: "2px 25px",
    margin: "24px 0",
    borderRadius: "5px",
    width: "10%",
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      // padding: "2px 25px",
      // margin: "24px 0",
    },
    [mobileScreen(theme)]: {
      fontSize: "18px",
      padding: "2px 0px",
      margin: "1px 0",
    }
  })
  // Title: styled('div')({
  //   display: "flex",
  //   width: "100%",
  //   height: 50,
  //   justifyContent: "center",
  //   alignItems: "flex-start",
  //   fontSize: 40,
  //   letterSpacing: 1,
  //   color: "#003E4C",
  //   fontWeight: 600,
  //   fontFamily: "Oswald",
  //   [emulatorScreen(theme)]: {
  //     fontSize: 30,
  //   },
  //   [mobileScreen(theme)]: {
  //     fontSize: 20,
  //   },
  // }),
}